import { useCallback } from 'react'

import { useGet } from './apiHooks'
import { tokenizer } from '../services/utils'
import { config } from '../components/Init/Init'
import { usePlayerStore } from '../services/store'

export const useGetPlayerPurchaseLimitData = () => {
  const playerStore = usePlayerStore()
  const playerSocialData = playerStore.use.socialData()
  const playerUserId = playerStore.use.userId()

  const { GET } = useGet()

  const getPurchaseLimitUrl =
    playerSocialData.wsBaseUrl + '/' + tokenizer(config.socialGetPurchaseLimitUrl, { '{accountId}': playerUserId })

  const getPlayerPurchaseLimitData = useCallback(() => {
    return GET(getPurchaseLimitUrl, { rawResponse: true })
  }, [GET, getPurchaseLimitUrl])

  return { getPlayerPurchaseLimitData }
}
